import type { NextPage } from 'next'
import Head from 'next/head'
import { TermosDeUso } from 'src/views'

const TemosDeUsoPage: NextPage = () => {
  return (
    <>
      <Head>
        <meta charSet="UTF-8" />

        <title>Termos de Uso - Crédito One</title>

        <meta
          property="og:description"
          content="Transparência é confiança. Entenda como funciona nossa contratação de empréstimo."
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:site_name" content="Crédito One" />
        <meta property="og:title" content="Termos de Uso - Crédito One" />

        <meta
          name="description"
          content="Transparência é confiança. Entenda como funciona nossa contratação de empréstimo."
        />
        <meta
          property="og:image"
          content="https://uploads-ssl.webflow.com/5fb18514177e609c5101c5b2/61aa78267b898128a13bbb31_open%20graph.png"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <TermosDeUso />
    </>
  )
}

export default TemosDeUsoPage
